const MATRIX_ROUTE_PREFIXES = [
  '/communications',
  '/passport',
  '/gig-passport',
  '/creative-lab',
  '/operator',
  '/admin/control-room',
];

const MATRIX_ROUTE_EXCLUSIONS = [
  '/passport/transmissions',
  '/passport/scan',
  '/passport/cities',
  '/passport/radar',
  '/gig-passport/transmissions',
  '/gig-passport/scan',
  '/gig-passport/cities',
  '/gig-passport/radar',
];

export const routeUsesMatrix = (pathname = '') => {
  if (MATRIX_ROUTE_EXCLUSIONS.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`))) {
    return false;
  }
  return MATRIX_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
};

export default routeUsesMatrix;
